import { useEffect } from "react"
import { useControl, useControlActionHistory } from "../../controlContext"
import { useSchema, useSchemaReducer } from "../../schemaContext"
import { createReportSchema } from "../../../../shared/Objects/newReportObjects/defaults/createReportSchema"

export function CreateReportHeaderWrapper({settings, setSettings, children}){

  const controls = useControl()
  const schemas = useSchema()
  const schemaReducer = useSchemaReducer()
  const actionHistory = useControlActionHistory()
  useEffect(()=>{
    if(!schemas.length) return 
    if(actionHistory[0].name !== 'duplicate') return
    let schemaIdx = schemas.findIndex(itm=>itm.name === createReportSchema.name)
    if(controls[0].duplicate && schemas[schemaIdx].content.length > 1){
      schemaReducer({type: '_init', schemas: [
        ...schemas.slice(0, schemaIdx),
        {...schemas[schemaIdx], content: [createReportSchema.content[0]]},
        ...schemas.slice(schemaIdx)
      ]})
      return
    } else if(schemas[schemaIdx].content.length < 2  ) {
      schemaReducer({type: '_init', schemas: [
        ...schemas.slice(0, schemaIdx),
        {...schemas[schemaIdx], content: createReportSchema.content},
        ...schemas.slice(schemaIdx)
      ]})
    }
  } ,[controls, actionHistory])

  return children || null
}